import React from "react";
import LanguageBloc from "../../../bloc/language_bloc";
import UtilBloc from "../../../bloc/util_bloc";
import "./app_content_field_item.css";

class AppStandartContentFieldItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      value: props.value,
    };
  }

  stateTitle() {
    return this.props.title || '';
  }
  stateValue() {
    return this.props.value || '';
  }

  stateField() {
    return this.props.field || '';
  }

  componentDidMount() {}

  render() {
    const title = this.stateTitle();
    const value = this.stateValue();
    const field = this.stateField();
    return (
      <>
        {title && value && (
          <div className="app-standard-content-field">
            <div className="app-content-field-tag">
              {title}
            </div>
            <div className="app-standard-content-field-content">
              
              {field?.prefix || ""}
              {value} {' '}
              {/* {field?.type === "number"
                ? parseFloat(value).toFixed(field?.fixed)
                : typeof value === "object"
                ? LanguageBloc.getTextForLocale(value)
                : value} */}
              { field?.suffix || ""}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default AppStandartContentFieldItem;
